const route = {
	path: 'new',
	name: 'customer-new',
	meta: {
		title: 'Nueva Compañía',
	},
	component: () => import('@/pages/customers/page-customer-new'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/customers-new.js